const state = {
  panelState: 1,
  userState: false,
  statementProcessorEnabled: false,
  accountExportEnabled: false,
};

export default state;
